import React, { useState, useEffect } from "react";
import Layout from "../Common/Layout";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const QualityOutbound = () => {
  const navigate = useNavigate();

  const [client, setClient] = useState();

  const cddNo = sessionStorage.getItem("cddNo");
  const token = sessionStorage.getItem("token");

  const fetchClient = async () => {
    try {
      const res = await axios.get(
        `https://irc.zentelex.com/api/delivery-order/by-cdd/${cddNo}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      // Save API response in state
      setClient(res.data.data);
    } catch (error) {
      console.error("Error fetching client:", error);
    }
  };

  useEffect(() => {
    if (cddNo) {
      fetchClient();
    }
  }, [cddNo]);

  console.log(client);

  const initialFormData = {
    entry_type: "OUTBOUND",
    samplingDate: "",
    analysisDate: "",
    clientName: sessionStorage.getItem("companyName"),
    clientAddress: "",
    commodityName: "",
    varietyName: "",
    warehouseName: "",
    warehouseAddress: "",
    crdNo: 0,
    cddNo: cddNo,
    noOfBags: "",
    quantity: "",
    odour: "",
    moistureContent: "",
    foreignMatter: "",
    damagedGrains: "%",
    weevilledGrain: "",
    immatureGrain: "",
    brokenGrain: "",
    otherFoodGrain: "",
    liveInsectPresence: "",
    liveInsectStatus: "",
    qaAnalystName: "",
    remarks: "",
  };

  const [formData, setFormData] = useState(initialFormData);

  const safe = (v) => v ?? "";

  useEffect(() => {
    if (client) {
      setFormData((prev) => ({
        ...prev,

        // 🔹 map API keys → form fields
        clientName: safe(client.clientName),
        clientAddress: safe(client.clientAddress),
        commodityName: safe(client.commodity),
        varietyName: safe(client.variety),
        warehouseName: safe(client.warehouse),
        warehouseAddress: safe(client.warehouseAddress),

        remarks: safe(client.remarks),
      }));
    }
  }, [client]);

  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData({
      ...formData,
      [id]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = sessionStorage.getItem("token");

      if (!token) {
        toast.error("❌ Unauthorized. Please login again.");
        return;
      }

      const response = await axios.post(
        "https://irc.zentelex.com/api/quality-qc",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.success) {
        toast.success("✅ QA Report Submitted Successfully!", {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });

        sessionStorage.setItem("qualityRecordId", response.data.data.id);

        setFormData(initialFormData);
      } else {
        toast.error(response.data.message || "❌ Failed to submit QA report");
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.message || "❌ Failed to submit QA report",
      );
    }
  };

  return (
    <>
      <Layout>
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <h4 className="page-title">QA Report</h4>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center mt-4">
                <div className="col-xxl-8 col-lg-10">
                  <div className="card shadow-sm border-0 rounded-3">
                    <div
                      className="card-body p-4"
                      style={{ backgroundColor: "#3075A6" }}
                    >
                      <h4 className="card-title mb-4 text-center fw-semibold text-white">
                        Quality Outbound Analysis Report
                      </h4>

                      <form onSubmit={handleSubmit}>
                        {/* Row 1: Sr No, Sampling Date, Analysis Date */}
                        <div className="row">
                          <div className="col-md-4 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Sampling Date:
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              id="samplingDate"
                              value={formData.samplingDate}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-4 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Analysis Date:
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              id="analysisDate"
                              value={formData.analysisDate}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        {/* Client, Commodity, Variety */}
                        <div className="row">
                          <div className="col-md-4 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Client / Depositor Name:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="clientName"
                              value={formData.clientName}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-4 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Client / Depositor Address:
                            </label>
                            <textarea
                              className="form-control"
                              id="clientAddress"
                              rows="2"
                              value={formData.clientAddress}
                              onChange={handleChange}
                              placeholder="Enter client address"
                            />
                          </div>
                          <div className="col-md-4 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Commodity Name:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="commodityName"
                              value={formData.commodityName}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-4 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Variety Name:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="varietyName"
                              value={formData.varietyName}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        {/* Warehouse Info */}
                        <div className="mb-3">
                          <label className="form-label text-white fw-semibold">
                            Warehouse Name:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="warehouseName"
                            value={formData.warehouseName}
                            onChange={handleChange}
                            placeholder="Enter warehouse name"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label text-white fw-semibold">
                            Warehouse Address:
                          </label>
                          <textarea
                            className="form-control"
                            id="warehouseAddress"
                            rows="2"
                            value={formData.warehouseAddress}
                            onChange={handleChange}
                            placeholder="Enter warehouse address"
                          />
                        </div>

                        {/* CRD, Bags, Quantity */}
                        <div className="row">
                          <div className="col-md-4 mb-3">
                            <label className="form-label text-white fw-semibold">
                              CDD No:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="crdNo"
                              value={formData.cddNo}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-4 mb-3">
                            <label className="form-label text-white fw-semibold">
                              No. of Bags:
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="noOfBags"
                              value={formData.noOfBags}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-4 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Quantity (MT):
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="quantity"
                              value={formData.quantity}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <hr />

                        {/* Quality Parameters */}
                        <h5 className="text-secondary text-white mb-3">
                          Quality Parameters
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Odour / Smell / Aroma:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="odour"
                              value={formData.odour}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Moisture Content:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="moistureContent"
                              value={formData.moistureContent}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Foreign Matter (%):
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="foreignMatter"
                              value={formData.foreignMatter}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Damaged & Discoloured Grains (%):
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="damagedGrains"
                              value={formData.damagedGrains}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Weevilled Grain:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="weevilledGrain"
                              value={formData.weevilledGrain}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Immature / Shrivelled / Shrunken Grains (%):
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="immatureGrain"
                              value={formData.immatureGrain}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Split & Broken Grains (%):
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="brokenGrain"
                              value={formData.brokenGrain}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Other Food Grains (%):
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="otherFoodGrain"
                              value={formData.otherFoodGrain}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        {/* Live Insect Presence */}
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Presence of Live Insect:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="liveInsectPresence"
                              value={formData.liveInsectPresence}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Live Insect Status (Few/Heavy):
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="liveInsectStatus"
                              value={formData.liveInsectStatus}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        {/* QA Analyst & Remarks */}
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label text-white fw-semibold">
                              QA Analyst Name:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="qaAnalystName"
                              value={formData.qaAnalystName}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label text-white fw-semibold">
                              Remarks:
                            </label>
                            <textarea
                              className="form-control"
                              id="remarks"
                              rows="2"
                              value={formData.remarks}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="text-center mt-4">
                          <button
                            type="submit"
                            className="btn px-5 py-2 fw-semibold"
                            style={{
                              backgroundColor: "#EC662C",
                              color: "white",
                            }}
                          >
                            Submit Report
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <ToastContainer />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default QualityOutbound;
